import React from "react";
import PropTypes from "prop-types";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import QuestionPreview from "../QuestionPreview";
import { CHARACTER_LIMIT_WARNING } from "../../constants";
import useStyles from "./styles";
import { useTranslation } from "react-i18next";
import { shortAnswerMaxCount } from "../../../services/constants";

const AnswerShort = (props) => {
  const { t } = useTranslation("surveyTaker");
  const styles = useStyles(props);
  return (
    <div className={styles.questionWrapper}>
      <QuestionPreview
        question={props.question}
        required={props.required}
        helperText={props.helperText}
        questionId={props.questionId}
        formattingType={props.formattingType}
        questionType="textfield"
      />
      <div className={styles.answer}>
        <TextareaAutosize
          data-testid="handle-answerShort-test"
          onChange={(e) => props.handleChange(e.target.value)}
          value={props.value}
          // maxChar={props.maxChar}
          // charLimitWarnMsg={props.charLimitWarnMsg}
          // placeholder={t("surveyTaker:answer")}
          className={styles.textArea}
          id={props.questionId}
          aria-describedby={`${props.questionId}-desc ${props.questionId}-error`}
          aria-required={props.required}
        />
        <div className={styles.textBottomContainer}>
          {props.value.length >= shortAnswerMaxCount && (
            <div className={styles.limitWarning}>
              {" "}
              {props.charLimitWarnMsg
                ? props.charLimitWarnMsg
                : t(CHARACTER_LIMIT_WARNING)}{" "}
            </div>
          )}
          <div className={styles.counterBox}>
            {props.value.length}/{shortAnswerMaxCount}
          </div>
        </div>
      </div>
    </div>
  );
};

AnswerShort.defaultProps = {
  question: "",
  required: false,
  handleChange: () => {},
  value: "",
};

AnswerShort.propTypes = {
  question: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  maxChar: PropTypes.number,
  charLimitWarnMsg: PropTypes.string,
};

export default AnswerShort;
